export const useTypography = ({ variant, as }) => {
  let computedAs = as;
  if (!computedAs && variant) {
    if (['h1', 'h2', 'h3', 'h4', 'h5', 'h6'].includes(variant)) {
      computedAs = variant;
    } else if (variant === 'paragraph') {
      computedAs = 'p';
    }
  }

  return {
    asTag: computedAs,
  };
};



// WEBPACK FOOTER //
// ./src/design-system/atoms/Typography/hooks/useTypography.js